document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 768) {
    new Swiper(".myFeatureSlider", {
      slidesPerView: 2.2,
      spaceBetween: 10,
      loop: false,

      // ONLY DOTS
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },

      // NO ARROWS
      navigation: false,
    });
  }
});


// gsap animtion start
// gsap.registerPlugin(ScrollTrigger);

// // Razor animation
// gsap.to('.razor-image', {
//   x: "50%", 
//   ease: "none",
//   duration:3,
//   scrollTrigger: {
//     trigger: ".razor-section",
//     start: "top top",
//     end: "bottom top",
//     scrub: true,
//   }
// });

// // Text animation
// gsap.to('.razor-text', {
//   x: "80%", 
//   opacity: 1,
//   ease: "none",
//   scrollTrigger: {
//     trigger: ".razor-section",
//     start: "top top",
//     end: "bottom top",
//     scrub: true
//   }
// });
// gsap animtion end
